import { LogisticSettings } from '../domain'
import LogisticRepository from '../infrastructure/logistic.repository'

export default class GetLogisticSettings {
  private readonly repository: LogisticRepository

  constructor(repository: LogisticRepository) {
    this.repository = repository
  }

  async execute(sellerId: string): Promise<LogisticSettings> {
    return this.repository.getSettings(sellerId)
  }
}
